import { GetTournamentQuery } from "generated/graphql";

const TournamentPageNavigation: React.FC<{
  setActiveSection: Function;
  activeSection: "info" | "registered" | "live" | "leaderboard";
  tournamentData?: GetTournamentQuery;
  calculateDateDifference: Function;
  tournamentDetailsMap: any;
}> = ({
  activeSection,
  setActiveSection,
  tournamentData,
  calculateDateDifference,
  tournamentDetailsMap,
}) => {
  return (
    <nav className="tourn_float_navbar">
      <button
        onClick={() => setActiveSection("info")}
        className={activeSection === "info" ? "active" : undefined}
      >
        INFO
      </button>
      <button
        onClick={() => setActiveSection("registered")}
        className={activeSection === "registered" ? "active" : undefined}
      >
        REGISTERED
      </button>
      {calculateDateDifference(tournamentData?.tournament?.tournamentDate[0]) >=
        0 && (
        <button
          onClick={() => setActiveSection("leaderboard")}
          id="leaderboard_section"
          className={activeSection === "leaderboard" ? "active" : undefined}
        >
          LEADERBOARD
        </button>
      )}
      {calculateDateDifference(
        tournamentData?.tournament?.tournamentDate[0]
      ) === 0 &&
        // @ts-ignore
        tournamentDetailsMap["liveEventId"] && (
          <button
            onClick={() => setActiveSection("live")}
            className={activeSection === "live" ? "active" : undefined}
          >
            LIVE
          </button>
        )}
    </nav>
  );
};

export default TournamentPageNavigation;
